import React from 'react';
import { INormalizedProduct } from '../../models/NormalizedProduct';
import { generateProductBullets } from '../../logic/Product';
import { useGetSearchSettingsQuery } from '../../store/endpoints/SearchSettingsEndpoints';
import MultiBoldBulletList from '../Common/MultiBoldBullet';
import BoostedAttributeHighlights from './BoostedAttributeHighlights';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store/rootReducer';
import { useMsal } from '@azure/msal-react';
import { updateSearchCriteria, updateSelectedSaveSearchId } from '../../store/searchSlice';

interface IProductNameDisplayProps {
    product: INormalizedProduct;
}

const ProductNameDisplay: React.FC<IProductNameDisplayProps> = (props) => {
    const org = useSelector((state: RootState) => state.settings.selectedOrganization);
    const user = useMsal().accounts[0]?.username;
    const searchSettings = useGetSearchSettingsQuery({org: org ?? '', user});
    const dispatch = useDispatch();
    const criteria = useSelector((state: RootState) => state.search.criteria);
    const bullets = generateProductBullets(props.product);

    // Clicking a bullet requires that attribute value, exactly as picking "Must Have" for it in the
    // facet panel would. The raw facet value goes into the filter (bullets normalize Yes/Included to
    // YES for display). Already-required values are left alone.
    const requireFacet = (name: string) => {
        const value = props.product.facets?.[name];
        if (!value) return;
        const must = criteria.must ?? [];
        if (must.some(a => a.name === name && a.value === value)) return;
        dispatch(updateSearchCriteria({...criteria, must: [...must, {type: 'facet', name, value}], page: 1}));
        dispatch(updateSelectedSaveSearchId(undefined));
    };
    const requireTitle = (name: string) => {
        const value = props.product.facets?.[name];
        return (criteria.must ?? []).some(a => a.name === name && a.value === value)
            ? `${name}: ${value} is already required`
            : `Require ${name}: ${value}`;
    };
    return (<div style={{width: '100%'}}>
        {props.product.name} {props.product.isConfigurable && <span style={{fontWeight: 'bold', color: '#777' }}> [Configurable]</span>}
        {bullets && searchSettings.data?.showFacetsInSearchResults
            ? Object.keys(bullets).length > 0 && <MultiBoldBulletList items={bullets} horizontal maxBullets={searchSettings.data.numberOfFacets} onSelect={requireFacet} selectTitle={requireTitle} />
            : null
        }
        <BoostedAttributeHighlights product={props.product} />
    </div>);
}

export default ProductNameDisplay;